(function (angular) {

  angular.module("alk.translations", [
    "pascalprecht.translate",
    "tmh.dynamicLocale",
    "ngCookies"
  ]);

})(window.angular);



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-translations/module.js